<!--
    描述：订阅查看工具-查询tab页列表数据
    时间：2020-06-17
    Created by yefan
-->
<template>
	<div class="w-table-layout w-table-page">
		<div class="w-table-content"
			 ref="tableContent">
			<el-table ref="xTable"
					  :height="tableH"
					  :data="filterData"
					  highlight-current-row
					  border
					  v-loading="loading"
					  stripe>
				<el-table-column type="index"
								 label="序号"
								 align="center"
								 width="100"></el-table-column>
				<el-table-column prop="sname"
								 label="材料名称"
								 align="center"
								 min-width="190"
								 show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="withTax"
								 label="含税价（元）"
								 align="center"
								 min-width="130"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="excise"
								 label="除税价（元）"
								 align="center"
								 min-width="130"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="areaName"
								 label="地区"
								 min-width="130"
								 align="center"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="yearAndMonth"
								 label="月份"
								 min-width="130"
								 align="center"
								 sortable
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="priceType"
								 label="信息价/市场价"
								 min-width="130"
								 align="center"
								 sortable
								 show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.priceType==1">信息价</span>
						<span v-if="scope.row.priceType==2">市场价</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="w-table-footer">
			<el-pagination @current-change="handleCurrentChange"
						   @size-change="handleSizeChange"
						   :current-page="currentPage"
						   :page-sizes="pageList"
						   :page-size="pageSize"
						   :total="total"
						   layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { selectResourcePrices } from '@/api/modules/analysis'

export default {
	name: 'Price-list',
	props: {
		showFilter: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			loading: false,
			tableH: 0,
			// 表格绑定的数据
			filterData: [],
			// 分页参数
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0 // 当前总条数
		}
	},
	created() {
		// 请求数据
		this.getlistData()
	},
	mounted() {
		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		//获得项目列表数据
		getlistData() {
			let params = Object.assign({}, this.queryParams);
			// 分页参数
			params.current = this.currentPage;
			params.size = this.pageSize;
			selectResourcePrices(params).then(res => {
				this.filterData = res.data.records;
				this.currentPage = parseInt(res.data.current);
				this.total = parseInt(res.data.total);
				this.pageSize = parseInt(res.data.size)
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val;
			this.getlistData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getlistData()
		}
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		}),
	},
	watch: {
		showFilter(val) {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		},
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
}
</script>

<style scoped lang="less">
.progress-cell {
	display: flex;
	justify-content: center;
}

.progress-content {
	min-width: 240px;
}

.progress-row {
	height: 18px;
	line-height: 18px;
}
</style>